import { Link } from "react-router-dom";
import { useState } from "react";

export default function QuoteCTA() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", product: "", message: "" });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const body = new URLSearchParams(formData as Record<string, string>);
      await fetch("https://readdy.ai/api/form/d720pp4991ove783t8d0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
    setSubmitting(false);
  };

  return (
    <section
      className="relative py-24 overflow-hidden"
      style={{ background: "linear-gradient(135deg, #1a1a1a 0%, #2d1f0e 100%)" }}
    >
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/9702ef9358711b5cdd46498aa6fca6a2.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <span
              className="text-amber-400 text-xs font-bold tracking-widest uppercase"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Free No-Obligation Quote
            </span>
            <h2
              className="text-4xl lg:text-5xl font-bold text-white mt-4 mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Ready to Transform Your Home?
            </h2>
            <p className="text-stone-300 text-base leading-relaxed mb-8" style={{ fontFamily: "'Raleway', sans-serif" }}>
              Get in touch today for your free, no-obligation quote. Our expert team will visit your property, assess your requirements, and provide a detailed written quotation — with no pressure and no hidden costs.
            </p>
            <div className="flex flex-col gap-4">
              {[
                { icon: "ri-phone-line", text: "Call us: 07852 636 300" },
                { icon: "ri-mail-line", text: "Email: sales@ensurewindows.co.uk" },
                { icon: "ri-time-line", text: "Mon–Fri: 8am–6pm, Sat: 9am–4pm" },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-amber-600/20 rounded-md">
                    <i className={`${item.icon} text-amber-400`}></i>
                  </div>
                  <span className="text-stone-300 text-sm" style={{ fontFamily: "'Raleway', sans-serif" }}>{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Quick Form */}
          <div className="bg-white/5 backdrop-blur border border-white/10 rounded-xl p-8">
            {submitted ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-600/20 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-amber-400 text-3xl"></i>
                </div>
                <h3 className="text-white text-xl font-bold mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Thank You!</h3>
                <p className="text-stone-300 text-sm" style={{ fontFamily: "'Raleway', sans-serif" }}>We&apos;ll be in touch within 24 hours.</p>
              </div>
            ) : (
              <>
                <h3 className="text-white text-xl font-bold mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Quick Enquiry</h3>
                <form onSubmit={handleSubmit} data-readdy-form className="space-y-4">
                  <input name="name" value={formData.name} onChange={handleChange} required placeholder="Your Name" className="w-full bg-white/10 border border-white/20 text-white placeholder-stone-400 text-sm px-4 py-3 rounded-md focus:outline-none focus:border-amber-400" style={{ fontFamily: "'Raleway', sans-serif" }} />
                  <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Email Address" className="w-full bg-white/10 border border-white/20 text-white placeholder-stone-400 text-sm px-4 py-3 rounded-md focus:outline-none focus:border-amber-400" style={{ fontFamily: "'Raleway', sans-serif" }} />
                  <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number" className="w-full bg-white/10 border border-white/20 text-white placeholder-stone-400 text-sm px-4 py-3 rounded-md focus:outline-none focus:border-amber-400" style={{ fontFamily: "'Raleway', sans-serif" }} />
                  <select name="product" value={formData.product} onChange={handleChange} required className="w-full bg-white/10 border border-white/20 text-stone-300 text-sm px-4 py-3 rounded-md focus:outline-none focus:border-amber-400" style={{ fontFamily: "'Raleway', sans-serif" }}>
                    <option value="">Select Product / Service</option>
                    <option>Aluminium Bifold Doors</option>
                    <option>uPVC Windows</option>
                    <option>Aluminium Windows</option>
                    <option>Composite Doors</option>
                    <option>Conservatories</option>
                    <option>Roof Lanterns</option>
                    <option>French Doors</option>
                    <option>Patio Doors</option>
                  </select>
                  <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Brief description of your project..." rows={3} maxLength={500} className="w-full bg-white/10 border border-white/20 text-white placeholder-stone-400 text-sm px-4 py-3 rounded-md focus:outline-none focus:border-amber-400 resize-none" style={{ fontFamily: "'Raleway', sans-serif" }} />
                  <button type="submit" disabled={submitting} className="w-full bg-amber-600 hover:bg-amber-500 text-white font-semibold py-3 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer" style={{ fontFamily: "'Raleway', sans-serif" }}>
                    {submitting ? "Sending..." : "Request Free Quote"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
